import { createStateHook, type HookStateFunction } from 'react-sweet-state';

import {
	type ChatStorePrivateState,
	type Conversation,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { chatStore } from './chatStore';

export const useCurrentConversation: HookStateFunction<Conversation | undefined, void> =
	createStateHook(chatStore, {
		selector: (state: ChatStorePrivateState) => state.conversations[state.currentConversationId],
	});
